export default __webpack_public_path__ + "static/media/payment-method-visa-grey-icon.f178d1df.svg";